import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setAuth } from '../Redux/authSlice';
import axios from 'axios';
import { RootState } from '../Redux/store';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Form, Button, Row, Col } from 'react-bootstrap';
import { Navigate } from 'react-router-dom';
import "./purchase.css"
interface Product {
    id: number;
    name: string;
}

interface Supplier {
    id: number;
    name: string;
}

export default function AddPurchaseComponent() {
    const [products, setProducts] = useState<Product[]>([]);
    const [suppliers, setSuppliers] = useState<Supplier[]>([]);
    const [productId, setProductId] = useState<number>(0);
    const [supplierId, setSupplierId] = useState<number>(0);
    const [quantity, setQuantity] = useState<number>(1);
    const [status, setStatus] = useState<string>('received');
    const [purchasePrice, setPurchasePrice] = useState<string>('');
    const [amountPaid, setAmountPaid] = useState<number>();
    const [datePurchased, setDatePurchased] = useState<string>(new Date().toISOString().slice(0, 10));
    const [paymentType, setPaymentType] = useState<string>('cash');
    const [redirect, setRedirect] = useState<boolean>(false);
    const dispatch = useDispatch();
    const auth = useSelector((state: RootState) => state.auth.value);

    const fetchProducts = async () => {
        try {
            const response = await axios.get('https://api.sominnovations.xyz/Branches/products/');
            setProducts(response.data.results);
        } catch (error) {
            console.error('Error fetching products:', error);
        }
    };

    const fetchSuppliers = async () => {
        try {
            const response = await axios.get('https://api.sominnovations.xyz/Branches/suppliers/');
            setSuppliers(response.data.results);
        } catch (error) {
            console.error('Error fetching suppliers:', error);
        }
    };

    useEffect(() => {
        fetchProducts();
        fetchSuppliers();
    }, []);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();

        const totalCost = (parseFloat(purchasePrice) * quantity).toFixed(2);
        const purchaseData = {
            product: productId,
            supplier: supplierId,
            quantity,
            purchase_price: purchasePrice,
            date_purchased: datePurchased,
            total_cost: totalCost,
            payment_type: paymentType, 
            status,
            amount_paid: amountPaid,
            balance: totalCost, 
            reference_number: `PUR-${new Date().toISOString()}-${Date.now()}`
        };

        try {
            await axios.post('https://api.sominnovations.xyz/Branches/purchase/', purchaseData);
            alert('Purchase added successfully!');
            setRedirect(true);
        } catch (error) {
            console.error("Error adding purchase:", error);
        }
    };

    if (redirect) {
        return <Navigate to="/purchase" />;
    }

    return (
        <div className="container-add mt-1" style={{ padding: '20px', border: '1px solid #ccc', borderRadius: '8px', }}>
            <h2 className="text-center mb-4">Add Purchase</h2>
            <Form onSubmit={handleSubmit}>
                <Row className="mb-3">
                    <Col md={6}>
                        <Form.Group controlId="formProduct">
                            <Form.Label>Product</Form.Label>
                            <Form.Control as="select" onChange={(e) => setProductId(Number(e.target.value))} required>
                                <option value="">Select Product</option>
                                {products.map(product => (
                                    <option key={product.id} value={product.id}>
                                        {product.name}
                                    </option>
                                ))}
                            </Form.Control>
                        </Form.Group>
                    </Col>
                    <Col md={6}>
                        <Form.Group controlId="formSupplier">
                            <Form.Label>Supplier</Form.Label>
                            <Form.Control as="select" onChange={(e) => setSupplierId(Number(e.target.value))} required>
                                <option value="">Select Supplier</option>
                                {suppliers.map(supplier => (
                                    <option key={supplier.id} value={supplier.id}>
                                        {supplier.name}
                                    </option>
                                ))}
                            </Form.Control>
                        </Form.Group>
                    </Col>
                </Row>

                <Row className="mb-3">
                    <Col md={6}>
                        <Form.Group controlId="formQuantity">
                            <Form.Label>Quantity</Form.Label>
                            <Form.Control type="number" value={quantity} onChange={(e) => setQuantity(Number(e.target.value))} min="1" required />
                        </Form.Group>
                    </Col>
                    <Col md={6}>
                        <Form.Group controlId="formPurchasePrice">
                            <Form.Label>Purchase Price</Form.Label>
                            <Form.Control type="text" value={purchasePrice} onChange={(e) => setPurchasePrice(e.target.value)} required />
                        </Form.Group>
                    </Col>
                </Row>

                <Row className="mb-3">
                    <Col md={6}>
                        <Form.Group controlId="formStatus">
                            <Form.Label>Status</Form.Label>
                            <Form.Control as="select" value={status} onChange={(e) => setStatus(e.target.value)}>
                                <option value="received">Received</option>
                                <option value="pending">Pending</option>
                            </Form.Control>
                        </Form.Group>
                    </Col>
                    <Col md={6}>
                        <Form.Group controlId="formAmountPaid">
                            <Form.Label>Amount Paid</Form.Label>
                            <Form.Control type="number" value={amountPaid || ''} onChange={(e) => setAmountPaid(Number(e.target.value))} required />
                        </Form.Group>
                    </Col>
                </Row>

                <Row className="mb-3">
                    <Col md={6}>
                        <Form.Group controlId="formDatePurchased">
                            <Form.Label>Date Purchased</Form.Label>
                            <Form.Control type="date" value={datePurchased} onChange={(e) => setDatePurchased(e.target.value)} required />
                        </Form.Group>
                    </Col>
                    <Col md={6}>
                        <Form.Group controlId="formPaymentType">
                            <Form.Label>Payment Type</Form.Label>
                            <Form.Control as="select" value={paymentType} onChange={(e) => setPaymentType(e.target.value)}>
                                <option value="cash">Cash</option>
                                <option value="check">Check</option>
                                <option value="mpesa">Mpesa</option>
                            </Form.Control>
                        </Form.Group>
                    </Col>
                </Row>

                <Button variant="primary" type="submit" className="w-100">
                    Add Purchase
                </Button>
            </Form>
        </div>
    );
}
